import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Error404 from './pages/error404';
import Info from './pages/info';
import Book from './pages/book';
import History from './pages/history';
import Explore from './pages/explore';
import Login from './pages/login';
import ScrollToTop from './components/common/ScrollToTop';

const Path = () => {
    return ( <>
    <BrowserRouter>
        <ScrollToTop />
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/Info' element={<Info />} />
            <Route path='/Book' element={<Book />} />
            <Route path='/History' element={<History />} />
            <Route path='/Explore' element={<Explore />} />
            <Route path='/Login' element={<Login />} />
            <Route path='*' element={<Error404 />} />
        </Routes>
    </BrowserRouter>
    </> );
}
 
export default Path;